import React from "react";

const ComingSoon = () => {
  return (
    <div className="coming-soon">
      <p>Coming Soon</p>
    </div>
  );
};

export default ComingSoon;
